/* bristm-service-hero — section script (loaded only where the section renders) */
(function () {
  if (window.BRISTM_SVC_HERO) return;
  window.BRISTM_SVC_HERO = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var active = new Set();
  var ticking = false;
  var listening = false;

  /* Slow parallax drift of the background photo (transform only, rAF, visible-only) */
  function update() {
    ticking = false;
    if (reduce.matches || !active.size) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var reads = [];
    active.forEach(function (el) {
      if (!el.isConnected) {
        active.delete(el);
        return;
      }
      reads.push([el, el.getBoundingClientRect()]);
    });
    reads.forEach(function (pair) {
      var r = pair[1];
      var media = pair[0].firstElementChild;
      if (!media) return;
      /* 0 while the stage is at rest at the top, 1 once it has scrolled out */
      var p = Math.max(0, Math.min(1, -r.top / Math.max(r.height, 1)));
      var shift = p * 40;
      var scale = 1 + 0.04 * p;
      media.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0) scale(' + scale.toFixed(4) + ')';
    });
  }

  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function setListening(on) {
    if (on === listening) return;
    listening = on;
    if (on) {
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request, { passive: true });
    } else {
      window.removeEventListener('scroll', request);
      window.removeEventListener('resize', request);
    }
  }

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) active.add(entry.target);
            else active.delete(entry.target);
          });
          setListening(active.size > 0 && !reduce.matches);
          request();
        })
      : null;

  function init(scope) {
    if (!observer) return;
    (scope || document).querySelectorAll('[data-b-svc-parallax]').forEach(function (el) {
      if (el.dataset.bBound) return;
      el.dataset.bBound = '1';
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
